import Events from '../../views/events/Index';
import ShowEvent from '../../views/events/Show';
import ShowEventAlbum from '../../views/events/Show';

export const EventsRouter = [
  {
    path: '/events',
    name: 'Events',
    component: Events,
  },
  {
    path: '/events/:id',
    name: 'ShowEvent',
    component: ShowEvent,
  },
  {
    path: '/events/:id/album/:album_id',
    name: 'ShowEventAlbum',
    component: ShowEventAlbum,
  }
];